var main =
webpackJsonp_name_([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

__webpack_require__(14);

// Modules
var cache = {}; // Precache Service Worker


function importAll(r) {
  r.keys().forEach(function (key) {
    cache[key] = r(key);
  });
}

importAll(__webpack_require__(15));

// Scroll to
$(function () {
  // var $sctollTo = $('.scroll-to');

  $('.scroll-to').on('click', function (event) {
    event.preventDefault();

    var animSpeed = 700;
    var $link = $(this);
    var hash = $link.attr('href');
    var $target = $(hash);

    if ($target.isset()) {
      $('html, body').stop().animate({
        'scrollTop': $target.offset().top - 140
      }, animSpeed, 'swing', function () {
        window.location.hash = hash;
      });
    }
  });

  // var $mainMenus = $('.main-menu');

  // if ($mainMenus.isset()) {
  //   $mainMenus.each(function() {
  //     var $menu = $(this);
  //     var $links = $menu.find('a[href^="#"]');
  //     var offset = parseInt($('.header__top').outerHeight());
  //     var animSpeed = 700;

  //     // Scroll on click
  //     $links.on('click', function(event) {
  //       event.preventDefault();
  //       var $link = $(this);

  //       var hash = $link.attr('href');
  //       var $target = $(hash);

  //       if ($target.isset()) {
  //         $('html, body').stop().animate({
  //           'scrollTop': $target.offset().top - offset - 20
  //         }, animSpeed, 'swing', function() {
  //           window.location.hash = hash;
  //         });
  //       }

  //     });

  //   });
  // }
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* eslint-env browser */


if ('serviceWorker' in navigator) {
	// Delay registration until after the page has loaded, to ensure that our
	// precaching requests don't degrade the first visit experience.
	// See https://developers.google.com/web/fundamentals/instant-and-offline/service-worker/registration
	window.addEventListener('load', function () {
		// Your service-worker.js *must* be located at the top-level directory relative to your site.
		// It won't be able to control pages unless it's located at the same level or higher than them.
		// *Don't* register service worker file in, e.g., a scripts/ sub-directory!
		// See https://github.com/slightlyoff/ServiceWorker/issues/468
		navigator.serviceWorker.register('precache.js').then(function (reg) {
			// updatefound is fired if service-worker.js changes.
			reg.onupdatefound = function () {
				// The updatefound event implies that reg.installing is set; see
				// https://w3c.github.io/ServiceWorker/#service-worker-registration-updatefound-event
				var installingWorker = reg.installing;

				installingWorker.onstatechange = function () {
					switch (installingWorker.state) {
						case 'installed':
							if (navigator.serviceWorker.controller) {
								// At this point, the old content will have been purged and the fresh content will
								// have been added to the cache.
								// It's the perfect time to display a "New content is available; please refresh."
								// message in the page's interface.
								console.log('New or updated content is available.');
							} else {
								// At this point, everything has been precached.
								// It's the perfect time to display a "Content is cached for offline use." message.
								console.log('Content is now available offline!');
							}
							break;

						case 'redundant':
							console.error('The installing service worker became redundant.');
							break;
					}
				};
			};
		}).catch(function (e) {
			console.error('Error during service worker registration:', e);
		});
	});
}

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./barrating/barrating.js": 16,
	"./catalog-menu/catalog-menu.js": 17,
	"./dropdown/dropdown.js": 18,
	"./header/header.js": 19,
	"./last-comments/last-comments.js": 20,
	"./main-menu/main-menu.js": 21,
	"./medicine-data/medicine-data.js": 22,
	"./medicine-description/medicine-description.js": 23,
	"./medicine-order/medicine-order.js": 24,
	"./mobile-menu-trigger/mobile-menu-trigger.js": 25,
	"./mobile-menu/mobile-menu.js": 26,
	"./modal/modal.js": 27,
	"./page/page.js": 28,
	"./phone-input/phone-input.js": 29,
	"./readmore/readmore.js": 30,
	"./slider-navigation/slider-navigation.js": 31,
	"./spinner/spinner.js": 32,
	"./tooltip/tooltip.js": 33
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

// barrating
(function () {

  $('.barrating__select').barrating({
    // theme: 'css-stars'
  });
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

// Catalog menu
(function () {
	var catalogMenu = '#catalog-menu';

	$(catalogMenu).on('click', function () {
		$(this).toggleClass('catalog-menu--open');
	});

	$(document).on('click', function (event) {
		if (!$(event.target).parents(catalogMenu).length) {
			if ($(catalogMenu).hasClass('catalog-menu--open')) $(catalogMenu).removeClass('catalog-menu--open');
		}
	});
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

// dropdown
(function () {
  'use strict';

  /**
   * Plugin name
   * @type {String}
   */

  var pluginName = 'dropdown';

  /**
   * Plugin default options
   * @type {Object}
   */
  var defaults = {
    outerClick: true,
    class: {
      base: 'dropdown',
      open: 'dropdown--open',
      disabled: 'dropdown--disabled'
    }
  };

  /**
   * Keyboard key codes
   * @type {Object}
   */
  var KEYCODE = {
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    ESCAPE: 27,
    TAB: 9
  };

  /**
   * Dropdown constructor
   * @constructor
   * @param {[jQuery]} element
   * @param {[Object]} options
   */
  function Plugin(element, options) {
    this.element = element;
    this._name = pluginName;
    this._defaults = defaults;

    this.$element = $(this.element);

    this.metadata = this.$element.data(this._name + '-' + 'options');

    this.options = $.extend({}, this._defaults, options, this.metadata);

    this.init();
  }

  $.extend(Plugin.prototype, {

    // Initialization logic
    init: function init() {
      this.buildCache();
      this.setA11yAttrs();

      if (this.isDisabled()) {
        this.setDisabledState();
      } else {
        this.bindEvents();
      }
    },

    // Remove plugin instance completely
    destroy: function destroy() {
      this.unbindEvents();
      this.$element.removeData();
    },

    // Cache DOM nodes for performance
    buildCache: function buildCache() {
      this.$trigger = this.$element.find('[data-dropdown-role="trigger"]');
      this.$dropMenu = this.$element.find('[data-dropdown-role="drop-content"]');
      this.focusableElements = this.$dropMenu.find('*[tabindex], a[href]');
      this.selected = 0;
      this.triggerId = this._name + '_trigger_' + this.options.count;
    },

    // Bind events that trigger methods
    bindEvents: function bindEvents() {
      var plugin = this;

      plugin.$trigger.on('click' + '.' + plugin._name, function (event) {
        plugin.toggle.call(plugin, event);
      });

      plugin.$trigger.add(this.focusableElements).on('keydown' + '.' + plugin._name, function (event) {
        plugin.handleKeydown.call(plugin, event);
      });

      $(document).on('click' + '.' + plugin._name, function (event) {
        plugin.outerClickHandler.call(plugin, event);
      });
    },

    // Unbind events that trigger methods
    unbindEvents: function unbindEvents() {
      this.$element.off('.' + this._name);
    },

    open: function open() {
      if (!this.isOpen()) {
        this.$element.addClass(this.options.class.open).trigger('opened' + '.' + this._name);
        this.$trigger.attr('aria-expanded', true);
      }
    },

    close: function close() {
      this.$element.removeClass(this.options.class.open).trigger('closed' + '.' + this._name);
      this.$trigger.attr('aria-expanded', false);
    },

    // Return true when dropdown is open
    isOpen: function isOpen() {
      var open = false;

      if (this.$element.hasClass(this.options.class.open)) {
        open = true;
      }

      return open;
    },

    // Return true when dropdown disabled
    isDisabled: function isDisabled() {
      var disabled = false;

      if (this.$element.hasClass(this.options.class.disabled)) {
        disabled = true;
      }

      return disabled;
    },

    // Toggle dropdown
    toggle: function toggle() {
      if (this.isOpen()) {
        this.close();
      } else {
        this.open();
      }
    },

    // Click outside
    outerClickHandler: function outerClickHandler(event) {
      if (this.options.outerClick && this.isOpen()) {
        if (!$(event.target).closest(this.$element).length) {
          this.close();
        }
      }
    },

    // Keydown handler
    handleKeydown: function handleKeydown(event) {

      if (this.isDisabled()) {
        return;
      }

      switch (event.which) {

        case KEYCODE.ESCAPE:
          // this.close();

          console.log(this.$trigger);
          this.$trigger.focus();

          break;

        case KEYCODE.UP:
        case KEYCODE.LEFT:

          event.preventDefault();

          this.open();

          if (this.selected === 0) {
            this.selected = this.focusableElements.length - 1;
          } else {
            this.selected--;
          }
          break;

        case KEYCODE.DOWN:
        case KEYCODE.RIGHT:

          event.preventDefault();

          this.open();

          if (this.selected === this.focusableElements.length - 1) {
            this.selected = 0;
          } else {
            this.selected++;
          }

          break;
      }

      this.focusableElements[this.selected].focus();
    },

    setA11yAttrs: function setA11yAttrs() {
      this.$trigger.attr({
        'aria-haspopup': true,
        'aria-expanded': false,
        'id': this.triggerId
      });

      this.$dropMenu.attr({
        'aria-labelledby': this.triggerId
      });
    },

    setDisabledState: function setDisabledState() {
      this.$element.attr('aria-disabled', true);
      this.$trigger.attr('disabled', true);
    },

    // Call calback by name
    callback: function callback(name) {
      var cb = this.options[name];

      if (typeof cb === 'function') {
        cb.call(this.element);
      }
    }

  });

  $.fn[pluginName] = function (options) {
    return this.each(function (index) {
      options = $.extend(options, { 'count': index });

      if (!$.data(this, 'plugin_' + pluginName)) {
        $.data(this, 'plugin_' + pluginName, new Plugin(this, options));
      }
    });
  };
})();

$(function () {
  $('.dropdown').dropdown();
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
    var page = $('.page'),
        header = $('#header'),
        headerTop = header.offset().top,
        headerHeight = header.outerHeight();

    if ($(document).scrollTop() > headerTop + headerHeight) {
        page.addClass('page--header-fixed');
    }

    $(document).scroll(function () {
        var scrollTop = $(document).scrollTop();

        if (scrollTop > headerTop + headerHeight) {
            page.addClass('page--header-fixed');
        } else {
            page.removeClass('page--header-fixed');
        }
    });
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

// last-comments
(function () {
	var lastComments = $('#last-comments');

	lastComments.slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		appendArrows: false
	});

	lastComments.on('swipe', function (event, slick, direction) {
		$('#slider-navigation-counter').find('.current').text(lastComments.slick('slickCurrentSlide') + 1);
	});
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

// main-menu
(function () {

  var $mainMenus = $('.main-menu');

  if ($mainMenus.isset()) {
    $mainMenus.each(function () {
      var $menu = $(this);
      var $links = $menu.find('a[href^="#"]');
      var offset = parseInt($('.header__top').outerHeight());
      var animSpeed = 700;

      // Scroll on click
      $links.on('click', function (event) {
        event.preventDefault();
        var $link = $(this);

        var hash = $link.attr('href');
        var $target = $(hash);

        if ($target.isset()) {
          $('html, body').stop().animate({
            'scrollTop': $target.offset().top - offset - 20
          }, animSpeed, 'swing', function () {
            window.location.hash = hash;
          });
        }
      });
    });
  }
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// // medicine-data
// (function() {

// 	// Your code here

// })();


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// // medicine-description
// (function() {

// 	// Your code here

// })();


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// // medicine-order
// (function() {

// 	// Your code here

// })();


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

// mobile-menu-trigger
(function () {

  var $trigger = $('.mobile-menu-trigger');
  var $page = $('.page');

  $trigger.on('click', function (event) {
    event.preventDefault();
    $page.toggleClass('page_mobile-menu_open');
  });
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

// mobile-menu
(function () {

  var $mobileMenus = $('.mobile-menu');
  var animSpeed = 400;

  if ($mobileMenus.isset()) {
    $mobileMenus.each(function () {
      var $mobileMenu = $(this);
      var $items = $mobileMenu.find('.mobile-menu__item');
      var $submenus = $mobileMenu.find('.mobile-menu__submenu');

      $items.on('click', function () {
        var $item = $(this);
        var $submenu = $item.find('.mobile-menu__submenu');

        if ($submenu.isset()) {
          $submenu.slideDown(animSpeed);
          $submenus.not($submenu).slideUp(animSpeed);
        }
      });
    });
  }
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

// Remodal
$(function () {
  $('[data-remodal-id]').remodal();
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

// page
(function () {
  var $page = $('.page');
  var $cover;

  $cover = $('<div class="page__cover">').appendTo($page);

  $cover.on('click', function (event) {
    event.preventDefault();

    if ($page.hasClass('page_mobile-menu_open')) {
      $page.removeClass('page_mobile-menu_open');
    }
  });
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

// phone-input
(function () {

	$('#phone-number').mask('+7 (999) 999-99-99');
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

// readmore
(function () {

	$('.readmore').readmore({
		collapsedHeight: 450,
		embedCSS: false,
		blockCSS: false,
		moreLink: '<div class="readmore__button"><a href="#"><span class="dotted">Развернуть полное описание</span></a></div>',
		lessLink: '<div class="readmore__button"><a href="#"><span class="dotted">Свернуть описание</span></a></div>'
	});
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

// slider-navigation
(function () {

	$('#slider-navigation-prev').on('click', function () {
		var sliderTarget = $('#' + $(this).data('slider')),
		    sliderCounter = $('#slider-navigation-counter');

		sliderTarget.slick('slickPrev');
		sliderCounter.find('.current').text(sliderTarget.slick('slickCurrentSlide') + 1);
	});

	$('#slider-navigation-next').on('click', function () {
		var sliderTarget = $('#' + $(this).data('slider')),
		    sliderCounter = $('#slider-navigation-counter');

		sliderTarget.slick('slickNext');
		sliderCounter.find('.current').text(sliderTarget.slick('slickCurrentSlide') + 1);
	});
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {
	$(".spinner").spinner({
		'delay': 200,
		'max': 99
	});
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

// Tooltip
(function () {

  var cssClasses = {
    visible: 'tooltip_visible',
    bottomRight: 'tooltip_bottom_right',
    bottomleft: 'tooltip_bottom_left',
    top: 'tooltip_top'
  };

  var $tooltips = $('[data-tooltip-id]');

  if ($tooltips.isset()) {
    $tooltips.each(function () {
      var that = this;
      var $that = $(that);
      var tooltipId = $that.data('tooltip-id');
      var $tooltip = $('[data-tooltip-target="' + tooltipId + '"]').first();

      $that.on('mouseenter.tooltip click.tooltip', function (event) {
        var props = event.target.getBoundingClientRect();
        var left = props.left + props.width;
        var marginLeft = -1 * $tooltip.outerWidth();
        var tooltipPos = {};

        tooltipPos.top = props.top + props.height + 15 + 'px';

        if ($tooltip.hasClass(cssClasses.bottomRight)) {
          tooltipPos.left = left + 'px';
          tooltipPos.marginLeft = marginLeft + 'px';
        } else {
          tooltipPos.left = props.left + 'px';
        }
        $tooltip.css(tooltipPos).addClass(cssClasses.visible);
      });

      $that.on('mouseleave.tooltip', function () {
        $tooltip.removeClass('tooltip_visible');
      });

      $(document).on('click', function (event) {
        if (!$(event.target).closest($that).length) {
          $tooltip.removeClass('tooltip_visible');
        }
      });

      $(window).on('scroll touchmove', function () {
        if ($tooltip.hasClass('tooltip_visible')) {
          $tooltip.removeClass('tooltip_visible');
        }
      });
    });
  }
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ })
],[13]);


// WEBPACK FOOTER //
// main.js